'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import * as pixel from '../lib/fpixel';
import { httpsCallable } from 'firebase/functions';
import { functions } from '@util/firebase';
import { useAuth } from 'context/AuthContext';
import { logError } from '@util/logError';
const FacebookPixel = () => {
  const [loaded, setLoaded] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    if (!loaded) return;

    pixel.pageview();
  }, [pathname, loaded]);

  const { user, userDoc } = useAuth();
  useEffect(() => {
    if (!user || !userDoc) return;
    if (process.env.NODE_ENV !== 'production') return;
    httpsCallable(
      functions,
      'v2_viewedPage'
    )({
      page: pathname,
      page_alt:
        pathname?.includes('shop') &&
        ![
          'all',
          'all-ties',
          'atv-tires',
          'auctions',
          'curated',
          'dirt-bike-tires',
          'featured',
          'motorcycle-tires',
          'parts',
          'recent',
          'riding-gear',
          'sale',
          'utv-tires',
        ].some((p) => pathname?.includes(p))
          ? 'CategoriesPage'
          : undefined,
    }).catch((error) => {
      logError(error);
    });
  }, [pathname, user, userDoc]);
  return (
    <div>
      <Script
        id="fb-pixel"
        src="/scripts/pixel.js" // public/scripts/pixel.js
        strategy="afterInteractive"
        defer
        onLoad={() => setLoaded(true)}
        data-pixel-id={pixel.FB_PIXEL_ID}
      />
    </div>
  );
};

export default FacebookPixel;

// Copied from https://github.com/vercel/next.js/blob/canary/examples/with-facebook-pixel/app/layout.js
